<template>
  <v-container class="component_main px-6 py-0">
    <v-row>
      <v-col cols=12>
        <h1>Extrato de Envio de Anexo de Faturamento (SIAD)</h1>
        <p>Solicite aqui o extrato.</p>
      </v-col>
      <v-col cols=12>
       <ExtratoFilter
          :prestadores="prestadores"
          :operadoras="listOperadora"
          :updateFilter="(formData, solicitaRelatorio) => updateFilter(formData, solicitaRelatorio)"
          :formatDate="(date) => formatDate(date)"
          :parseDate="(date) => parseDate(date)"
          :validarForm="validarForm"
          :getOperadoras="(opts) => getOperadoras(opts)"
          :getResponsaveis="(item) => getResponsaveis(item)"
          :responsaveis="listResponsavel"
          :statusFilter="statusFilter"
          />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ExtratoFilter from "@/components/recebiveis/extrato_envio_anexo_faturamento/Filter";

export default {
  components: {
    ExtratoFilter
  },
  data() {
    return {
      //filter:{},
      filteredList: [],
      legendas: {
        apresentado: "Apresentado",
        liberado: "Liberado",
        glosado: "Glosado",
        aconciliar: "À conciliar"
      },
      prestadores: [],
      validarForm: false,
      statusFilter:[]
    }
  },
  watch: {
    grupoEconomico:{
      deep: true,
      handler() {
        this.prestadores = this.$store.getters["permissions/getPrestadoresByGeco"]();
      }
    }
  },
  computed: {
    ...mapState({
      filter: (state) => state.faturamento.extratofilter,
      grupoEconomico: (state) => state.permissions.grupoEconomico,
      grupoEconomicoList: state =>state.permissions.grupoEconomicoList,
      listOperadora: (state) => state.faturamento.listOperadora,
      listResponsavel: (state) => state.faturamento.listResponsavel,
      userData: (state) => state.userData.userData,
    }),
  },
  beforeUpdate() {
    this.prestadores = this.$store.getters["permissions/getPrestadoresByGeco"](); 
  },
  beforeMount(){
this.statusFilter = [
      {
      id: null,
      descricao: 'Selecione',
      color: null,
      }, {
        id: "Concluidos",
        descricao: "Concluído em ${this.monName[(new Date).getMonth()]}/${(new Date).getFullYear().toString()}",
        color: "#32B88B",
      },{
        id: "Fechados",
        descricao: "Concluído",
        color: "#32B88B",
      },{
        id: "AConcluir",
        descricao: "Aguardando conclusão",
        color: "#B2B842",
      },{
        id: "Processando",
        descricao: "Em processamento (envio automático)",
        color: "#4A4A4A",
      },{
        id: "ProcessandoManual",
        descricao: "Em processamento (envio manual)",
        color: "#4A4A4A"
      },{
        id: "NaoIniciados",
        descricao: "Não iniciado",
        color: "#979797"
      },{
        id: "Critica",
        descricao: "Com crítica",
        color: "#D0021B"
      },{
        id: "AEnvio",
        descricao: "Aguardando transmissão",
        color: "#FC5F17"
      },{
        id: "Atrasados",
        descricao: "Em Atraso",
        color: "#FFA500"
      }
    ]
  },
  mounted(){
    this.prestadores = this.$store.getters["permissions/getPrestadoresByGeco"](); 
    let opts = {
          grupo_economico: this.grupoEconomico,
          limitar: false,
          modulo_operadora: "recebiveis",
          prestador_ids: []
        }
    this.getOperadoras(opts)
  },
  methods: {
    ...mapActions('permissions', [
      "getOperadoras"
    ]),
    ...mapActions('faturamento', [
      "getResponsaveis"
    ]),
    formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
    parseDate (date) {
        if (!date) return null
        const [day, month, year] = date.split('/')
        return `${year}-${month}-${day}`
    },
    updateFilter(filter, solicitaRelatorio) {
      if(filter != undefined && filter != null){
          //this.filter = filter;
          filter.filtername = "extratoSIADFilter"
          this.$store.commit("faturamento/setExtratoFilter", filter, {root:true})
          
          if(solicitaRelatorio)
            this.solicitaRelatorioConfirm(filter)
      }
    },
    solicitaRelatorioConfirm(filter) {
      let msg_complementar = "";
      if(filter.complementar){
        msg_complementar = "Apenas <b>lotes complementares</b><br>";
      }
      if(filter.complementar){
        msg_complementar = "Apenas <b>lotes complementares</b><br>";
      }
      let msg_busca_generica = "";
      if(filter.tipo_busca != null && filter.tipo_busca !="") {
        switch(filter.tipo_busca){
          case "nota_fiscal":
            msg_busca_generica = `<br>Nota Fiscal de número: <strong>${filter.nota_fiscal}</strong>`
            break
          case "protocolo":
            msg_busca_generica = `<br>Protocolo de número: <strong>${filter.protocolo}</strong>`
            break
          case "num_lote":
            msg_busca_generica = `<br>Número do lote: <strong>${filter.num_lote}</strong>`
            break
          default:
            break
        }
      }
      if(filter.card_name !="" && filter.card_name != null){
        msg_busca_generica += `<br>Status do cronograma: ${filter.card_name}`;
      }
      let prestador = this.filter.prestador_ids.length?this.filter.prestador_ids.map( prest => this.prestadores.find(p=>p.id == prest).prest_nome).join(', ')+'.' : 'Todos'
      let operadora = this.filter.operadora_ans_id.length?this.filter.operadora_ans_id.map( oper => this.listOperadora.find(p=>p.id == oper).oper_nome).join(', ')+'.' : 'Todos'
      let dataInicial = this.formatDate(this.filter.data_inicio)
      let dataFinal = this.formatDate(this.filter.data_fim)
      let paramModal = {
        type: "info",
        title: "Solicitar extrato ... com o filtro:",
        message: `
          ${msg_complementar}
          Prestador(es): <strong>${prestador}</strong><br>
          Operadora(s): <strong>${operadora}</strong><br>
          Período de <strong>${dataInicial}</strong> até <strong>${dataFinal}</strong>
          ${msg_busca_generica}
          `,
        callback: () => this.solicitaRelatorio(this.filter),
        btConfirm: { name: "Solicitar", show: true },
        btCancel: { name: "Cancelar", show: true }
      }
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    },
    solicitaRelatorio(formData) {
      let opts = {}
      if(formData == null){
        opts = Object.assign(this.pagination, { grupoEconomico: this.grupoEconomico, limitar: false }, this.filter)
        this.solicitaRelatorioConfirm(opts)
        return
      }
      formData.grupo_economico = this.grupoEconomico

      let acao ="getExtratoFatEnvioAnexo"
      let payload = formData

      var data = {
        query: 
        [{
          "Modulo": "recebiveis",
          "Acao": acao,
          "Payload": payload
        }]
      };

      this.$store.dispatch("request/doRequest", data).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader");
          return;
        }
        let paramModal = {
          type: response.warning? "warning":"success",
          title: "Atenção!",
          message: response.mensagem,
          callback: () => {},
          btConfirm: { name: "Ok", show: true },
        }
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      })
    },
    validaForm(){
      console.log("validaForm")
      this.validarForm = true
      this.$nextTick(()=>this.validarForm = false)
    }
  }
};
</script>
<style>
</style>